export const eventsConstants = {
  CHECKOUT_STARTED: 'checkout.started',
  CHECKOUT_COMPLETED: 'checkout.completed',
  CHECKOUT_USER_SIGNUP: 'checkout.user.signup',
  CHECKOUT_USER_SOCIAL: 'checkout.user.social',
  CHECKOUT_CART_UPDATED: 'checkout.cart.updated',

  CHECKOUT_GA_ADD_TO_CART: 'add_to_cart',
  CHECKOUT_GA_REMOVE_FROM_CART: 'remove_from_cart',
  CHECKOUT_GA_BEGIN_CHECKOUT: 'begin_checkout',
  CHECKOUT_GA_SIGN_UP: 'sign_up',
  CHECKOUT_GA_LOGIN: 'login',
  CHECKOUT_GA_ADD_PAYMENT_INFO: 'add_payment_info',
  CHECKOUT_GA_PURCHASE: 'purchase',
}

export const eventsList = {
  [eventsConstants.CHECKOUT_STARTED]: [
    'coupon',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'special_offer',
    'available_plans',
  ],
  [eventsConstants.CHECKOUT_COMPLETED]: [
    'checkoutTotal',
    'paymentMethod',
    '3dsFlow',
    'planCode',
    'coupon',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'special_offer',
    'available_plans',
  ],
  [eventsConstants.CHECKOUT_CART_UPDATED]: [
    'paymentMethod',
    '3dsFlow',
    'planCode',
    'coupon',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'special_offer',
    'available_plans',
    'trigger',
    'email',
    'productsCodes',
  ],
  [eventsConstants.CHECKOUT_USER_SIGNUP]: [
    'from',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'special_offer',
    'available_plans',
  ],
  [eventsConstants.CHECKOUT_USER_SOCIAL]: [
    'socialApp',
    'checkoutTotal',
    'paymentMethod',
    'planCode',
    'coupon',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'special_offer',
  ],
}
